var map = {
	"./frontend/AndroidGuide.vue": 68470,
	"./frontend/Banking.vue": 38194,
	"./frontend/BetslipHistory.vue": 21073,
	"./frontend/BodyFB.vue": 28178,
	"./frontend/Commission.vue": 22232,
	"./frontend/ContactUs.vue": 94493,
	"./frontend/DataTable.vue": 36107,
	"./frontend/Deposit.vue": 52187,
	"./frontend/History.vue": 12713,
	"./frontend/Home.vue": 23405,
	"./frontend/IOSGuide.vue": 32327,
	"./frontend/Iframe copy.vue": 34991,
	"./frontend/Iframe.vue": 95139,
	"./frontend/Index.vue": 17734,
	"./frontend/Live.vue": 31445,
	"./frontend/LiveScore.vue": 72184,
	"./frontend/MainMenu.vue": 7194,
	"./frontend/MatchResult.vue": 86569,
	"./frontend/MaungFB.vue": 8272,
	"./frontend/Promotion.vue": 10502,
	"./frontend/Setting.vue": 184,
	"./frontend/VideoLink.vue": 23157,
	"./frontend/VipLevels.vue": 28798,
	"./frontend/Withdraw.vue": 473,
	"./frontend/auth/Login.vue": 63064,
	"./frontend/auth/Register.vue": 90916,
	"./frontend/auth/Rule.vue": 24557,
	"./frontend/auth/Verify.vue": 72659,
	"./frontend/auth/VerifyNotAuth.vue": 2395,
	"./frontend/components/AccountSelect.vue": 90035,
	"./frontend/components/AppHeader.vue": 17452,
	"./frontend/components/DataTable.vue": 55613,
	"./frontend/components/FBPreviewVoucher.vue": 97612,
	"./frontend/components/FBVoucher.vue": 4039,
	"./frontend/components/FootballTeamCard.vue": 76549,
	"./frontend/components/GroupBox.vue": 86983,
	"./frontend/components/HomeBanner.vue": 59207,
	"./frontend/components/InputSelectDrawModal.vue": 92334,
	"./frontend/components/LuckyWheel.vue": 34451,
	"./frontend/components/NormalBox.vue": 63243,
	"./frontend/components/PreviewVoucher.vue": 25507,
	"./frontend/components/SideNav.vue": 30850,
	"./frontend/components/Table.vue": 66459,
	"./frontend/components/ThreedGroupBox.vue": 95959,
	"./frontend/components/TwoDSelect.vue": 89795,
	"./frontend/components/Voucher.vue": 65409,
	"./frontend/normal-user/2d/2d.vue": 96556,
	"./frontend/normal-user/2d/ClosedDays.vue": 45716,
	"./frontend/normal-user/2d/Home.vue": 90363,
	"./frontend/normal-user/2d/Winner.vue": 89110,
	"./frontend/normal-user/3d/3d.vue": 82728,
	"./frontend/normal-user/3d/Home.vue": 17999,
	"./frontend/normal-user/DreamBooks.vue": 15,
	"./frontend/normal-user/Index.vue": 56012,
	"./frontend/normal-user/bugyee/Room.vue": 38345,
	"./frontend/normal-user/game/Arcade.vue": 10607,
	"./frontend/normal-user/game/Fishing.vue": 90722,
	"./frontend/normal-user/game/Game.vue": 728,
	"./frontend/normal-user/game/Slot.vue": 75845,
	"./frontend/normal-user/shankomee/Room.vue": 61017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;